import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

// material-ui
import { ButtonBase } from "@mui/material";

// project imports
import config from "config";
import Logo from "components/Logo";
import { MENU_OPEN } from "store/actions";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const dispatch = useDispatch();
  return (
    <ButtonBase
      disableRipple
      component={Link}
      to={config.defaultPath}
      onClick={() => dispatch({ type: MENU_OPEN, id: "portfolio" })}
    >
      <Logo />
    </ButtonBase>
  );
};

export default LogoSection;
